import styled from "styled-components";

import theme from "@/constants/theme";

import solarPanel from "../../../public/solarPanel.jpg";

export const Container = styled.div`
  background-color: ${theme.colors.primary100};
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  padding: 8px;
`;

export const Infos = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${theme.colors.white};
  margin-right: 8px;
  border-radius: 32px;
`;

export const Img = styled.div`
  height: 100%;
  border-radius: 30px;

  div {
    width: 100%;
    height: 100%;
    background-image: url(${solarPanel});
    background-repeat: no-repeat;
    background-position: -500px -250px;
    border-radius: 32px;
  }
`;

export const Access = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Form = styled.form`
  height: auto;

  .forms-input {
    width: 100%;

    .input {
      width: 100%;
      padding-bottom: 20px;
    }
  }

  .button {
    width: 65%;
  }
`;
